import classNames from 'classnames';
import * as React from 'react';
import styles from './ClanRole.module.scss.js';

var ClanRole = React.memo(function (props) {
    var _a;
    return (React.createElement("i", { className: classNames(styles[props.role], props.className, (_a = {},
            _a[styles.isLarger] = props.isLarger,
            _a)) }));
});

export { ClanRole as default };
//# sourceMappingURL=ClanRole.js.map
